import React, {useState} from 'react'
import {useDispatch} from 'react-redux'
import {useNavigate} from 'react-router-dom'
import {FiChevronDown, FiChevronRight, FiPlus, FiUsers} from 'react-icons/fi'
import {VmoMenu, VmoMenuItem, VmoAccordion, VmoAccordionTitle, VmoAccordionContent, VmoButton} from 'vmo-library'

import LockPermissionTooltip from 'components/common/LockPermissionTooltip'
import AddCompanySegment from 'components/pages/Customers/Segment/AddCompanySegment'
import AddContactSegment from 'components/pages/Customers/Segment/AddContactSegment'
import useUserPermissions from 'hooks/pure/useUserPermission'
import {isActiveNavlink} from 'utils/helper'
import {getContactList} from 'actions'

const CustomersMenu = () => {
  const [activeAccordion, setActiveAccordion] = useState({activeContact: true, activeCompanies: true})
  const [currentStepContact, setCurrentStepContact] = useState('')
  const [currentStepCompany, setCurrentStepCompany] = useState('')
  const navigate = useNavigate()
  const dispatch = useDispatch()

  const {customerManagementAccess, contactsPermissions} = useUserPermissions()
  const allowCustomerListFeature = customerManagementAccess?.customerList
  const allowManageContactsRole = contactsPermissions?.manage_contacts

  return (
    <VmoMenu vertical secondary className="set-list customers-menu">
      <VmoAccordion>
        <VmoAccordionTitle
          onClick={() => setActiveAccordion({...activeAccordion, activeContact: !activeAccordion.activeContact})}
        >
          Contacts
          <div className="d-flex">
            {activeAccordion.activeContact && (
              <LockPermissionTooltip
                isFeatureAccessDenied={!allowCustomerListFeature}
                isRoleAccessDenied={!allowManageContactsRole}
              >
                <VmoButton
                  className="vmo-seg"
                  onClick={e => {
                    e.stopPropagation()
                    if (allowCustomerListFeature && allowManageContactsRole) {
                      setCurrentStepContact('step1')
                    }
                  }}
                >
                  <FiPlus />
                </VmoButton>
              </LockPermissionTooltip>
            )}
            {activeAccordion.activeContact ? <FiChevronDown /> : <FiChevronRight />}
          </div>
        </VmoAccordionTitle>
        <VmoAccordionContent active={activeAccordion.activeContact}>
          <VmoMenuItem
            active={isActiveNavlink('/customers', true)}
            onClick={() => {
              navigate(`/customers`)

              dispatch(getContactList({}))
            }}
          >
            <FiUsers /> All Contacts
          </VmoMenuItem>
          {allowCustomerListFeature && (
            <AddContactSegment currentStep={currentStepContact} setCurrentStep={setCurrentStepContact} />
          )}
        </VmoAccordionContent>
      </VmoAccordion>

      <VmoAccordion>
        <VmoAccordionTitle
          onClick={() => setActiveAccordion({...activeAccordion, activeCompanies: !activeAccordion.activeCompanies})}
        >
          Companies
          <div className="d-flex">
            {activeAccordion.activeCompanies && (
              <LockPermissionTooltip
                isFeatureAccessDenied={!allowCustomerListFeature}
                isRoleAccessDenied={!allowManageContactsRole}
              >
                <VmoButton
                  className="vmo-seg"
                  onClick={e => {
                    e.stopPropagation()
                    if (allowCustomerListFeature && allowManageContactsRole) {
                      setCurrentStepCompany('step1')
                    }
                  }}
                >
                  <FiPlus />
                </VmoButton>
              </LockPermissionTooltip>
            )}
            {activeAccordion.activeCompanies ? <FiChevronDown /> : <FiChevronRight />}
          </div>
        </VmoAccordionTitle>
        <VmoAccordionContent active={activeAccordion.activeCompanies}>
          <VmoMenuItem
            active={isActiveNavlink('/customers/companies')}
            onClick={() => navigate(`/customers/companies`)}
          >
            <FiUsers /> All Companies
          </VmoMenuItem>
          {allowCustomerListFeature && (
            <AddCompanySegment type="company" currentStep={currentStepCompany} setCurrentStep={setCurrentStepCompany} />
          )}
        </VmoAccordionContent>
      </VmoAccordion>
    </VmoMenu>
  )
}

export default CustomersMenu
